import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reviewReports: {
		id: 'servicedesk-sla-settings.metrics.summary-with-actions.delete-metric-modal.report-list.review-reports',
		defaultMessage:
			'This will also remove the metric from reports. The following reports have a series that uses {tagStart}{metricName}{tagEnd} :',
		description: 'Review the reports which using the metric in their series before deleting it',
	},
});
